import { useMemo, useState } from 'react'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
}

const INITIAL_CANHOTO = {
  prestacao_contas_data: new Date().toISOString(),
  patrimonio_movimentacao_id: 1,
  num_nf_canhoto: 'LIT123421',
  patrimonio_name: 'Palete CHEP',
  qte: 50,
  status: 'Pendente',
  patrimonio_owner_name: 'Lorem Ipsum',
  tp_name: 'TP Valinhos',
  vehicle_badge: 'TTT-2121',
}

const INITIAL_STATE = {
  canhoto: { ...INITIAL_CANHOTO },
  selectedStatus: '',
  updatedCanhoto: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalValidacaoCanhoto() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events

      onInit(canhoto) {
        setState(prevState => ({ ...prevState, canhoto: canhoto }))
      },
    }
  }, [])

  return { state, localDispatch }
}
